import { createReducer, on } from '@ngrx/store';
import {
  addVendorTagging, clearTaggingStore, updateVendorTagging,
} from './TaggedVendors.action';
import {
  VendorTagging,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';

export const initialState: TaggingState = {
  tags: []
};
export interface TaggingState {
  tags: VendorTagging[]; // Assuming Tag is the type for your tags
}

export const taggingReducer = createReducer(
  initialState,

  on(addVendorTagging, (state, { tagging }) => ({
    ...state,
    tags: tagging
  })),

  on(updateVendorTagging, (state, { tagging }) => ({
    ...state,
    tags: tagging
  })),

  on(clearTaggingStore, (state) => {
    return {
      ...initialState,
    };
  }),
);
